import React from "react";
import { Link } from 'react-router-dom';

function Automatizacion(){
  return(
    <section>
      <div class="row align-items-center bgbackg1">
        <div class="col-4 text-centr">
            <div className="text-start">
                <p class="h2 blanco">Servicios Automatizados</p>
                <h7 class="blanco">Estamos más cerca de ti</h7>
            </div>
        </div>
        <div class="col-6">
            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739658/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-17.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
        </div>
      </div>
      <div class="text-center">
        <div class="my-5">
            <div class="row justify-content-evenly">
                <div class="col text-centr2">
                    <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                        Recursos Humanos
                    </button>
                </div>
            </div>
            <div class="collapse" id="collapseExample">
                <div class="row justify-content-evenly">
                    
                    <div class="col">
                        <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-02.png" alt="..."></img>
                        </a>
                        <h5>Préstamo administrativo</h5>
                    </div>
                    <div class="col">
                        <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-03.png" alt="..."></img>
                        </a>
                        <h5>Anticipo de nómina</h5>
                    </div>
                    <div class="col">
                        <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-02.png" alt="..."></img>
                        </a>
                        <h5>Fondo de ahorro</h5>
                    </div>
                </div>
            
                <div class="row justify-content-evenly espacio">
                    
                                     
                    {/* <div class="col">
                        <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/069a66f9-f63f-48ff-a6d9-bd883013fa9e">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                        </a>
                        <h5>Reportes</h5>
                    </div> */}
                <div class="col">
                            <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                        </a>
                        <h5>Bonos operativos</h5>
                    </div>   
                    
                {/* <div class="row justify-content-evenly espacio">                    
                    <div class="col">
                        <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/cc86bbbc-c510-46c0-91ff-42ab5e073a89">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                        </a>
                        <h5>Retroalimentación de bonos</h5>
                    </div>
                    <div class="col">
                        <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/6a613a98-9949-4104-9c51-7f595a73c8d4">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                        </a>
                        <h5>Consulta de bonos</h5>
                    </div>
                </div>  */}
                </div>
            </div>
        
            <div class="row justify-content-evenly color_colum">
                <div class="col text-centr2">
                    <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample">
                        Contabilidad
                    </button>
                </div>
            </div>
            <div class="collapse color_colum" id="collapseExample1">
                <div class="row justify-content-evenly">                        
                    <div class="col">
                            <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                            </a>
                            <h5>Solicitud de viáticos</h5>
                    </div>
                    
                    <div class="col">
                            <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-05.png" alt="..."></img>
                            </a>
                            <h5>Comprobación de viáticos</h5>
                    </div>
                </div>
            </div>

            <div class="row justify-content-evenly">
                <div class="col text-centr2">
                    <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
                        Soporte
                    </button>
                </div>
            </div>
            <div class="collapse" id="collapseExample2">
                <div class="row justify-content-evenly">  
                    <div class="col">
                        <a target="_blank" href="">
                            <img src="" alt=""></img>
                        </a>
                        <h5></h5>
                    </div>                 
                <div class="col">
                        <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                        </a>
                        <h5>Tickets</h5>
                    </div>
                    <div class="col">
                            <a target="_blank" href="">
                            <img src="" alt=""></img>
                        </a>
                        <h5></h5>
                    </div>   
                </div>
            </div>
        </div>
      </div>
    </section>
  )
}

export default Automatizacion;